import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './payment.css';

const Payment = () => {
  const [amount, setAmount] = useState('');
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    // Fetch payment history on page load
    const fetchPaymentHistory = async () => {
      try {
        const response = await axios.get('/api/payments/history'); // Replace with actual endpoint
        setPaymentHistory(response.data);
      } catch (error) {
        console.error('Error fetching payment history:', error);
      }
    };
    fetchPaymentHistory();
  }, []);

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/api/payments/initiate', { amount }); // Replace with actual payment API endpoint

      // Assuming successful response from the payment initiation API
      if (response.data.success) {
        // Redirect to payment gateway
        window.location.href = response.data.paymentGatewayUrl; // This should redirect the user to the payment page (e.g., Stripe, PayPal)
      } else {
        alert('Payment initiation failed.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      alert('An error occurred while processing the payment.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-container">
      <h2>Make a Payment</h2>

      {/* Payment Form */}
      <form onSubmit={handlePaymentSubmit} className="payment-form">
        <label htmlFor="amount">Amount to Pay:</label>
        <input
          type="number"
          id="amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="Enter amount"
          required
        />
        <button type="submit" className="payment-button" disabled={loading}>
          {loading ? 'Processing...' : 'Proceed to Payment'}
        </button>
      </form>

      {/* Payment History */}
      <div className="payment-history">
        <h3>Payment History</h3>
        {paymentHistory.length > 0 ? (
          <ul>
            {paymentHistory.map((payment) => (
              <li key={payment.id}>
                <span>{payment.date}</span>
                <span>${payment.amount}</span>
                <span>{payment.status}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p>No payments found.</p>
        )}
      </div>
    </div>
  );
};

export default Payment;
